import config from 'sharedConfig';
import { getCategoriesByTag, getProductsByUrl } from 'shared/models/api';
import { registerError } from 'components/errorPages/actions';

const init = {
  groupName: '',
  title: '',
  subtitle: '',
  description: '',
  categories: []
};

const CATEGORY_GROUP_UPDATE = 'CATEGORY_GROUP_UPDATE';
const CATEGORY_GROUP_LOADING = 'CATEGORY_GROUP_LOADING';
const CATEGORY_GROUP_CLEAR = 'CATEGORY_GROUP_CLEAR';

export default function(state = init, action = {}) {
  switch (action.type) {
    case CATEGORY_GROUP_UPDATE:
      return {
        ...state,
        ...action.parentCategory,
        loading: false,
        groupName: action.groupName,
        categories: action.categories
      };
    case CATEGORY_GROUP_LOADING:
      return { ...state, loading: true };
    case CATEGORY_GROUP_CLEAR:
      return init;
    default:
      return state;
  }
}

export function unloadCategoryGroup() {
  return dispatch => dispatch({ type: CATEGORY_GROUP_CLEAR });
}

export function loadCategoryGroup(groupName) {
  return (dispatch, getState) => {
    if (getState().categoryGroup.loading) return Promise.resolve();

    dispatch({ type: CATEGORY_GROUP_LOADING });

    const configCategory = config.nav[groupName];
    const promise =
      configCategory && configCategory.tag
        ? fetchConfigCategory(configCategory)
        : fetchPsuedoCategory(name);

    return promise.then(categories => {
      if (
        !categories ||
        !categories.length ||
        categories.every(({ products }) => !products || !products.length)
      ) {
        const error = { status: 404, message: 'Category Group Not Found' };
        dispatch(registerError(error));
      }

      dispatch({
        type: CATEGORY_GROUP_UPDATE,
        groupName,
        parentCategory: configCategory || {},
        categories
      });
    });
  };
}

function fetchConfigCategory(category) {
  const tags = category.tag.split(',');
  const hitsPerPage = 12;
  return getCategoriesByTag(tags, {
    hitsPerPage,
    facets: []
  }).then(categories =>
    (categories || []).map(category => ({
      ...category,
      products: (category.products || []).slice(0, hitsPerPage)
    }))
  );
}

function fetchPsuedoCategory(name) {
  return getProductsByUrl(name).then(result => {
    const title = (result[0] && result[0].title) || '';
    return [{ title, products: result }];
  });
}
